import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import 'dayjs/locale/uz'
import 'dayjs/locale/en'

export function formatReservationDate(reserve_date: string, start_time: string, end_time: string, locale: string) {
  return `${dayjs(reserve_date).locale(locale).format('DD MMM')} ${start_time} - ${end_time}`
}

export const formatDate = (dateString: string) => {
  return dayjs(dateString).format('DD.MM.YYYY')
}